import styles from './styles.module.css';

type Props = {
  numIban?: string;
  nomBanque?: string;
  disabled?: boolean;
  gestionnaire?: string;
  prudence?: string;
  risque?: number;
  name?: string;
  type?: string;
  isChecked?: boolean;
  onChange?: () => void;
};

const CardIbanGestionPilotee = ({
  numIban,
  nomBanque,
  disabled,
  gestionnaire,
  prudence,
  risque,
  name,
  type,
  isChecked,
  onChange,
}: Props) => {
  const boxStyle = disabled ? styles.cardDisabled : '';

  const radioPosition =
    numIban === '' || numIban === null || numIban === undefined ? '' : ` ${styles.radioPositionManaged}`;
  let content;

  if ((numIban === '' || numIban == null) && (nomBanque === '' || nomBanque == null)) {
    content = (
      <div className={styles.managedContentContainer}>
        <div className={styles.titleContainer}>
          <span className={styles.title}>
            Gestion Pilotée
            {type === 'Gestion Pilotée à Horizon Retraite' ? ' à Horizon Retraite' : ''}
          </span>
        </div>
        <div className={styles.content}>
          <span className={styles.contentRow}>
            {gestionnaire} - {prudence}
          </span>
          <span className={`${styles.contentRow} ${styles.riskRow}`}>
            Risque{' '}
            <span className={styles.riskGrade}>
              <span>{risque}</span>/7
            </span>
          </span>
        </div>
      </div>
    );
  } else {
    content = (
      <div className={styles.ibanContentContainer}>
        <div className={styles.ibanContent}>
          <span className={styles.fieldLabel}>IBAN</span>
          <span className={`${styles.fieldValue} iban-infos`}>{numIban}</span>
        </div>
        <div className={styles.bankContent}>
          <span className={styles.fieldLabel}>Banque</span>
          <span className={styles.fieldValue}>{nomBanque}</span>
        </div>
      </div>
    );
  }

  return (
    <div className={`${styles.card} ${boxStyle}`}>
      <label className={styles.radioLabel}>
        {content}

        <input type="radio" disabled={disabled} name={name} onChange={onChange} defaultChecked={isChecked} required />
        <span className={`${styles.radioDisplay}${radioPosition}${disabled ? ` ${styles.radioDisabled}` : ''}`}></span>
      </label>
    </div>
  );
};

export default CardIbanGestionPilotee;
